import { listDestinations, SyncAdapter } from "./api";

const ALL_SYNC_ADAPTERS: SyncAdapter[] = ["outline"];

export async function loadDestinationTitles(
  preferredAdapter?: SyncAdapter | null,
): Promise<Record<string, string>> {
  const adapters = preferredAdapter
    ? [preferredAdapter, ...ALL_SYNC_ADAPTERS.filter((adapter) => adapter !== preferredAdapter)]
    : ALL_SYNC_ADAPTERS;
  const titles: Record<string, string> = {};

  for (const adapter of adapters) {
    try {
      const destinations = await listDestinations(adapter);
      for (const destination of destinations) {
        if (!titles[destination.id]) {
          titles[destination.id] = destination.title;
        }
      }
    } catch {
      // Individual adapters can be unavailable; continue.
    }
  }

  return titles;
}

/**
 * The human-readable name of a destination, or undefined when it is not known.
 *
 * Deliberately does not fall back to the page id: an unresolved id is a 36
 * character unbreakable string, and rendering it in a chip wrecks the row it
 * sits in. Callers that need "is there a destination at all" should ask the
 * link, not this function — the title is unavailable whenever the adapter
 * cannot be reached, which says nothing about whether a target is set.
 */
export function resolveDestinationTitle(
  pageId?: string | null,
  pageTitles: Record<string, string> = {},
): string | undefined {
  if (!pageId) {
    return undefined;
  }

  return pageTitles[pageId];
}

/** Label for a destination whose title could not be resolved. */
export const UNKNOWN_DESTINATION_LABEL = 'Synced';
